export enum TileTitles {
  BrandName = 'Brand',
  BriefName = 'Activation name',
  Objective = 'Objective',
  TargetAudience= "Target Audience"
}
